import angular from "angular";
import core from "../../core/core.module";
import registerRequest from "../register-request.service";

let mod = angular.module('RegisterRequest.rejectRegisterRequest', [core, registerRequest])
    .component('rejectRegisterRequest', {
        controller: ['RegisterRequest', 'notifier', controller],
        template: require('./reject-register-request.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(RegisterRequest, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.registerRequest = $ctrl.resolve.registerRequest;
        $ctrl.comment = null;
    };

    $ctrl.submit = function () {
        $ctrl.loading = true;
        RegisterRequest
            .reject($ctrl.registerRequest.id, $ctrl.comment)
            .then(
                function () {
                    $ctrl.loading = false;
                    $ctrl.close({$value: {comment: $ctrl.comment}});
                },
                function (error) {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(error);
                }
            );
    };

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/register-requests-control/reject-register-request/reject-register-request.js